import { FC, PropsWithChildren } from "react";
import styles from "./sample-subheader.module.scss";

const SampleSubheaderGroup: FC<PropsWithChildren> = ({ children }) => (
  <div className={styles.subheader_group}>{children}</div>
);

export default SampleSubheaderGroup;
